export class ConfirmationDialogModel {
    constructor(public title: string, public message: string) { }
}